import { ActionOutboxEntityType, StopwatchStopGap } from 'src/WebApiController';

export type IStopwatchLoggingContext = {
  startEvent: (
    key: string,
    id: string,
    logWhenAllGapsPresent: string[],
    entityType?: ActionOutboxEntityType
  ) => void;
  addStopGap: (
    key: string,
    id: string,
    logWhenAllGapsPresent: string[],
    eventName: string,
    entityType?: ActionOutboxEntityType
  ) => void;
};

export enum StopwatchLoggingId {
  InventoryPortfolioPage = 'InventoryPortfolioPage',
  InventoryEventPage = 'InventoryEventPage',
  InventorySearchPage = 'InventorySearchPage',

  SalePortfolioPage = 'SalePortfolioPage',
  SaleSearchPage = 'SaleSearchPage',
  SaleEventPage = 'SaleEventPage',

  PurchasePortfolioPage = 'PurchasePortfolioPage',
  PurchaseSearchPage = 'PurchaseSearchPage',
  PurchaseEventPage = 'PurchaseEventPage',

  SaleActivityPosEntityModal = 'SaleActivityPosEntityModal',
  PurchaseActivityPosEntityModal = 'PurchaseActivityPosEntityModal',
  InventoryActivityPosEntityModal = 'InventoryActivityPosEntityModal',
}

export enum StopwatchLoggingEventName {
  LogStart = 'PageStartLoad',
  EventInfoLoad = 'EventInfoLoad',
  EventMetricsLoad = 'EventMetricsLoad',
  EventitiesApiRequestReceived = 'EventEntitiesApiRequestReceived',
  EventEntitiesLoad = 'EventEntitiesLoad',
  EntityLoad = 'EntityLoad',
  EntityDataLoad = 'EntityDataLoad',
}

export type IStopwatchEntry = {
  id: string;
  key: string;
  entityType?: ActionOutboxEntityType;
  startTime: Date;
  endTime: Date | undefined;
  startFrameTimeMs?: number;
  endFrameTimeMs?: number;
  totalTimeMs: number | undefined;
  stopGaps: {
    [key: string]: StopwatchStopGap;
  };
  logWhenAllGapsPresent: string[];
};
